import { render, staticRenderFns } from "./ratings.vue?vue&type=template&id=26b5da82&scoped=true&"
import script from "./ratings.vue?vue&type=script&lang=js&"
export * from "./ratings.vue?vue&type=script&lang=js&"
import style0 from "./ratings.vue?vue&type=style&index=0&id=26b5da82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b5da82",
  null
  
)

export default component.exports